/**
 * Canonical helper for the BlissNet Discover participation toggle.
 *
 * Source of truth: users.dating_preferences.looking_for_date (boolean).
 *
 * Rules:
 * - Explicit true / 'true'  -> participate.
 * - Explicit false / 'false' -> opted out.
 * - Missing/null/malformed  -> opted out (dating is opt-in).
 */

/**
 * Resolve whether a user participates in Discover from their dating_preferences.
 * Opt-in: only explicit true participates. Missing/null/malformed → false.
 */
export function resolveLookingForDate(prefs: unknown): boolean {
  if (prefs && typeof prefs === 'object') {
    const value = (prefs as Record<string, unknown>).looking_for_date;
    if (value === false || value === 'false') return false;
    if (value === true || value === 'true') return true;
  }
  // Missing/null/legacy/malformed → opt-in required.
  return false;
}

/**
 * Merge the canonical looking_for_date key into existing dating_preferences,
 * preserving all unrelated keys. Returns a new object (never mutates input).
 */
export function mergeLookingForDate(
  existing: unknown,
  lookingForDate: boolean
): Record<string, unknown> {
  const base =
    existing && typeof existing === 'object'
      ? { ...(existing as Record<string, unknown>) }
      : {};
  base.looking_for_date = lookingForDate;
  return base;
}
